<template>
  <div>
    <highcharts :id="id" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(highcharts)

var idx = 0

export default {
  props: {
    QuestM: {
      type: Object,
      default: () => {}
    },
    QuestD: {
      type: Array,
      default: () => {}
    }
  },
  created() {
    this.init()
  },
  data() {
    idx++
    return {
      id: 'ChartBar' + String(idx),
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.QuestM.cnName
        },
        yAxis: {
          title: {
            text: '次數',
            align: 'middle'
          },
          labels: {
            overflow: 'justify'
          }
        },
        xAxis: {
          type: 'category'
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [
          {
            name: '',
            colorByPoint: true,
            data: []
          }
        ]

        //
      }
    }
  },
  mounted() {
    
    var obj = {
      'id': this.id,
      'option': this.chartOptions
    }

    this.$store.state.charts.push(obj);
    
    // var chart = Highcharts.chart(this.id, this.chartOptions)
    // this.$store.state.charts.push(chart)
    
  },
  methods: {
    init() {
      this.chartOptions.series[0].name = '人數'
      if (this.QuestM.questItemType == 26) {
        for (let i = 0; i < this.QuestD.length; i++) {
          if (this.QuestD[i].enName == this.QuestM.enName) {
            var x = {
              name: this.QuestD[i].options + '顆星',
              y: parseInt(this.QuestD[i].sum)
            }
            //window.console.log(this.QuestD[i].sum)
            this.chartOptions.series[0].data.push(x)
          }
        }
      } else if (this.QuestM.questItemType == 14) {
        //單選題

        for (let i = 0; i < this.QuestD.length; i++) {
          if (this.QuestD[i].enName == this.QuestM.enName) {
            var cnNameArray = this.QuestM.item.split('$')
            for (let j = 0; j < cnNameArray.length; j++) {
              if (this.QuestD[i].options == j) {
                var x = { name: cnNameArray[j], y: parseInt(this.QuestD[i].sum) }
              }
            }

            //window.console.log(this.QuestD[i].sum)
            this.chartOptions.series[0].data.push(x)
          }
        }
      } else if (this.QuestM.questItemType == 16) {
        //多選題
        // peter fix logic start 2020/10/19
        // 設置一個統計物件 {cnName: 次數}
        var staticObjs = {}
        this.QuestM.item.split('$').forEach(cnName => {
          staticObjs[cnName] = 0
        })
        // 計算每個 cnName 被選中的次數
        this.QuestD.filter(d => d.enName == this.QuestM.enName).forEach(d => {          
          let itemArr = d.item.split('$')
          d.options.split('$').forEach(i => {
            let item = itemArr[i] // 從 options 紀載的 cnName index 取得 cnName
            staticObjs[item] += parseInt(d.sum) // 累加 (typo)
          })
          let itemName = d.item.split('$')[d.options]
          // staticObjs[itemName] += parseInt(d.sum) // 累加 //(X)多餘
        })
        // 加到統計圖表當中
        for (const [cnName, cnt] of Object.entries(staticObjs)) {
          if (cnt != 0) {
            var x = { name: cnName, y: parseInt(cnt) }
            // window.console.log(x)
            this.chartOptions.series[0].data.push(x)
          }
        }
        // peter fix end 2020/10/19
      } else if (this.QuestM.questItemType == 18 && this.QuestM.arraySerial != 0) {
        //矩陣題個題目
        var cnNameArray = this.QuestM.item.split('$')
        for (let i = 0; i < this.QuestD.length; i++) {
          if (this.QuestD[i].enName == this.QuestM.enName) {
            for (let j = 0; j < cnNameArray.length; j++) {
              if (this.QuestD[i].options == j) {
                var x = { name: cnNameArray[j], y: parseInt(this.QuestD[i].sum) }
              }
            }

            //window.console.log(this.QuestD[i].sum)
            this.chartOptions.series[0].data.push(x)
          }
        }
      } else {
        //TODO 未知題型
      }
    }
  }
}
</script>
